  import React from "react";
  import "../../pages/services/components/religiousservices.css";
  import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
  import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
  import { DatePicker } from "@mui/x-date-pickers/DatePicker";
  import { Link, useParams } from "react-router-dom";
  import PoojaBasket from "../../components/common/Basket/PoojaBoasket/PoojaBasket";
  import { logEvent } from "../../utils/analytics";
  import templeJson from '../../config/temple.json';
  import { Button, Container, Grid, TextField } from "@mui/material";
  import { Add, Remove } from "@mui/icons-material";
  import { useServiceHandler } from "./customHook";

  function SinglepageView() {
    const isStyleOne = templeJson["Services"]?.style === 1;
    const servicestyle = {
      head: isStyleOne ? "page-header py-4 service-head-dt" : "page-header py-4 service-head-svt"
    }
    const params = useParams();
    const {
      serviceData,
      selectedDate,
      setSelectedDate,
      quantityCounts,
      increaseQuantity,
      decreaseQuantity,
      handleOrderPuja,
    } = useServiceHandler(params);

    function convertUTCtoLocal(utcDateString) {
      const utcDate = new Date(utcDateString);
      const offsetMinutes = utcDate.getTimezoneOffset();
      const localTime = new Date(utcDate.getTime() - offsetMinutes * 60000);
      return localTime;
    }

    return (
      <>
        <Container maxWidth={'xl'} className={servicestyle?.head}>
          <h1 className="text-center service-head display-6 breadcrumb-h1">
            {serviceData?.title}
          </h1>
          <ul className="breadcrumb justify-content-center mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={`/services/${serviceData?.category_slug}`}>
                {serviceData?.category}
              </Link>
            </li>
            <li className="breadcrumb-item active">{serviceData?.title}</li>
          </ul>
        </Container>
        <Container className="py-5">
          <Grid className="text-center mb-5">
            <h6 className="section-title text-center text-primary text-uppercase title-tl">
              {serviceData?.category}
            </h6>
            <h1 className="mb-3">
              <span className="text-secundary">{serviceData?.title}</span>
            </h1>
          </Grid>
          {/* //------------------------------------------------ */}
          <Grid container spacing={2}>
            <Grid item lg={8} md={8} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <img
                    width={340}
                    height={377}
                    src={serviceData?.image}
                    alt={serviceData?.title}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  {/* Date Picker and Quantity */}
                  <Grid className="d-flex justify-content-between mb-3 mt-3">
                    <Grid className="">
                      {/* //datepicker based on the services------------------------------ */}
                      {serviceData?.category_slug === "daily" ? (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{ width: "100%" }}
                            label="Select a date"
                            value={selectedDate[serviceData?._id]}
                            onChange={(date) =>
                              setSelectedDate((prevDates) => ({
                                ...prevDates,
                                [serviceData?._id]: date,
                              }))
                            }
                            shouldDisableDate={(date) => {
                              const currentDate = new Date();
                              currentDate.setHours(0, 0, 0, 0);
                              new Date(date).setHours(0, 0, 0, 0);
                              return date < currentDate;
                            }}
                          />
                        </LocalizationProvider>
                      ) : serviceData?.category_slug === "weekly" ? (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Select a date"
                            value={selectedDate[serviceData?._id]}
                            onChange={(date) => {
                              setSelectedDate((prevDates) => ({
                                ...prevDates,
                                [serviceData?._id]: date,
                              }));
                            }}
                            shouldDisableDate={(date) => {
                              if (serviceData?.sync_type !== 3) {
                                const currentDate = new Date();
                                const startDate = new Date(serviceData?.start);
                                const endDate = new Date(serviceData?.end);
                                currentDate.setHours(0, 0, 0, 0);
                                return (
                                  date < currentDate ||
                                  date < startDate ||
                                  date > endDate
                                );
                              } else {
                                return (
                                  new Date(date).getDay() !==
                                  Number(serviceData?.days)
                                );
                              }
                            }}
                          />
                        </LocalizationProvider>
                      ) : serviceData?.category_slug === "monthly" ? (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Select a date"
                            value={selectedDate[serviceData?._id]}
                            onChange={(date) => {
                              setSelectedDate((prevDates) => ({
                                ...prevDates,
                                [serviceData?._id]: date,
                              }));
                            }}
                            shouldDisableDate={(date) => {
                              if (serviceData?.sync_type !== 3) {
                                const currentDate = new Date();
                                const startDate = new Date(serviceData?.start);
                                const endDate = new Date(serviceData?.end);
                                currentDate.setHours(0, 0, 0, 0);
                                return (
                                  date < currentDate ||
                                  date < startDate ||
                                  date > endDate
                                );
                              } else {
                                const currentDate = new Date();
                                if (date < currentDate) {
                                  return true;
                                }
                                const year = new Date(date).getFullYear();
                                const month = new Date(date).getMonth();
                                const firstDayOfMonth = new Date(year, month, 1);

                                const firstDayOfWeek = firstDayOfMonth.getDay();
                                const offset =
                                  (serviceData?.days - firstDayOfWeek + 7) % 7;
                                const position = Number(
                                  serviceData?.positions.replace(/\D/g, "")
                                );
                                const firstSelectableDate = new Date(
                                  year,
                                  month,
                                  1 + offset + (Number(position) - 1) * 7
                                );
                                return (
                                  new Date(date).getDate() !==
                                    firstSelectableDate.getDate() ||
                                  new Date(date).getMonth() !==
                                    firstSelectableDate.getMonth() ||
                                  new Date(date).getFullYear() !==
                                    firstSelectableDate.getFullYear()
                                );
                              }
                            }}
                          />
                        </LocalizationProvider>
                      ) : serviceData?.category_slug === "annual" ? (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Select a date"
                            value={selectedDate[serviceData?._id]}
                            onChange={(date) => {
                              setSelectedDate((prevDates) => ({
                                ...prevDates,
                                [serviceData?._id]: date,
                              }));
                            }}
                            shouldDisableDate={(date) => {
                              const currentDate = new Date();
                              const startDate = new Date(serviceData?.start);
                              const endDate = new Date(serviceData?.end);

                              currentDate.setHours(0, 0, 0, 0);

                              return (
                                date < currentDate ||
                                date < startDate ||
                                date > endDate
                              );
                            }}
                          />
                        </LocalizationProvider>
                      ) : serviceData?.category_slug === "special" ? (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Select a date"
                            value={selectedDate[serviceData._id]}
                            onChange={(date) => {
                              setSelectedDate((prevDates) => ({
                                ...prevDates,
                                [serviceData._id]: date,
                              }));
                            }}
                            shouldDisableDate={(date) => {
                              const currentDate = new Date();
                              const startDate = new Date(serviceData?.start);
                              const endDate = new Date(serviceData?.end);

                              currentDate.setHours(0, 0, 0, 0);

                              return (
                                date < currentDate ||
                                date < startDate ||
                                date > endDate
                              );
                            }}
                          />
                        </LocalizationProvider>
                      ) : serviceData?.category_slug === "vahana_sevas" ? (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Select a date"
                            value={selectedDate[serviceData?._id]}
                            onChange={(date) => {
                              setSelectedDate((prevDates) => ({
                                ...prevDates,
                                [serviceData?._id]: date,
                              }));
                            }}
                            shouldDisableDate={(date) => {
                              const currentDate = new Date();
                              const startDate = new Date(serviceData?.start);
                              const endDate = new Date(serviceData?.end);

                              currentDate.setHours(0, 0, 0, 0);

                              return (
                                date < currentDate ||
                                date < startDate ||
                                date > endDate
                              );
                            }}
                          />
                        </LocalizationProvider>
                      ) : (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{ width: "100%" }}
                            label="Select a date"
                            value={selectedDate[serviceData?._id]}
                            onChange={(date) =>
                              setSelectedDate((prevDates) => ({
                                ...prevDates,
                                [serviceData?._id]: date,
                              }))
                            }
                            shouldDisableDate={(date) => {
                              const currentDate = new Date();
                              currentDate.setHours(0, 0, 0, 0);
                              new Date(date).setHours(0, 0, 0, 0);
                              return date < currentDate;
                            }}
                          />
                        </LocalizationProvider>
                      )}
                    </Grid>
                    <Grid className="" id="attemple">
                      <Grid className="input-group quantity mx-auto">
                        <Grid className="input-group-btn">
                          <Button
                            variant="contained"
                            color="primary"
                            className="quantity-btn"
                            onClick={() => decreaseQuantity(serviceData?._id)}
                          >
                            <Remove sx={{color:'white',fontWeight:'bold'}} fontSize="5px"/>
                          </Button>
                        </Grid>
                        <TextField
                          type="text"
                          className="form-control text-center"
                          value={quantityCounts[serviceData?._id] || 1}
                        />
                        <Grid className="input-group-btn">
                          <Button
                            variant="contained"
                            color="primary"
                            className="quantity-btn"
                            onClick={() => increaseQuantity(serviceData?._id)}
                          >
                            <Add sx={{color:'white',fontWeight:'bold'}} fontSize="5px"/>
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* Price and Order Button */}
                  <Grid className="d-flex justify-content-between mb-2 mt-3">
                    <Grid className="d-flex align-items-center">
                      <h2 className="religious-subtitle">
                        $ {serviceData?.amount}
                      </h2>
                    </Grid>
                    <Grid className="">
                      <Grid style={{ width: "100%" }}>
                        <Button
                          variant="contained"
                          color="primary"
                          className="request_puja_btn"
                          onClick={() => {
                            handleOrderPuja(serviceData);
                            logEvent(
                              "Puja Request",
                              "Request Puja Clicked",
                              serviceData.title
                            );
                          }}
                          style={{ width: "100%" }}
                        >
                          Order Puja
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                  <hr />
                  {/* Description */}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: serviceData?.description,
                    }}
                  ></div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <PoojaBasket />
            </Grid>
          </Grid>
        </Container>
      </>
    );
  }
  export default SinglepageView;
